import React from 'react';
import {StyleSheet} from 'react-native';
import {Box, ScrollView} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import Markdown from 'react-native-markdown-display';
import {useSalesmanContext} from '../../../../../../context/salesman';
import InternalTemplate from '../../../../../../components/templates/internal';
import {StackParamList} from '../../../../../../navigators';
import {isWebApp} from '../../../../../../utils/platform/is-web';
import {SecondaryButton} from '../../../../../../components/buttons';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanCustomerHelpDocuments'
>;

export const HelpDocumentsScreen = ({navigation}: ScreenProps) => {
  const handleGoBack = () => {
    navigation.pop(1);
  };

  const {customerRequiredDocumentsHelp} = useSalesmanContext();

  const handleCancelButtonPress = () => {
    handleGoBack();
  };

  return (
    <InternalTemplate
      title={'salesman-add-client-documents-title'}
      childContainerStyle={styles.childContainerStyle}
      backButton={{
        label: 'go-back',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}
      contentPaddingX="0">
      <ScrollView
        paddingTop={5}
        contentInset={{bottom: 50}}
        showsVerticalScrollIndicator={isWebApp}>
        <Markdown style={styles} mergeStyle={true}>
          {customerRequiredDocumentsHelp ?? ''}
        </Markdown>
        <Box mt={5} marginX={4}>
          <SecondaryButton label="close" onPress={handleCancelButtonPress} />
        </Box>
      </ScrollView>
    </InternalTemplate>
  );
};
const styles = StyleSheet.create({
  body: {
    color: 'black',
  },
  childContainerStyle: {
    paddingBottom: '25%',
    margin: 30,
  },
});
